export const updatePageName = (payload) => {
  return {
    type: "UPDATE_PAGE_NAME",
    payload,
  };
};
